<div class="map-container" [ngClass]="!environment.mobile ? 'desktop' : ''">
    <div id="map"></div>
</div>